export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/deleteResource',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allResources'],
       
    })
